import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgbNavModule, NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {ColorPickerDirective} from 'ngx-color-picker';
import {FormsModule} from '@angular/forms';
import {SharedModule} from '@shared/shared.module';
import {BrandingComponent} from '@components/administration/organization/configuration/branding/branding.component';
import {MailSettingsComponent} from '@components/administration/organization/configuration/mail/mail-settings.component';
import {MailPreviewComponent} from '@components/administration/organization/configuration/mail/mail-preview/mail-preview.component';
import {BrandingImageComponent} from '@components/administration/organization/configuration/branding/branding-image.component';
import {MailTemplateComponent} from '@components/administration/organization/configuration/mail/mail-template/mail-template.component';
import {MachinesComponent} from '@components/administration/organization/configuration/machines/machines.component';
import {UsersComponent} from '@components/administration/organization/configuration/users/users.component';
import {SettingsComponent} from '@components/administration/organization/configuration/settings/settings.component';
import {ConfigurationComponent} from '@components/administration/organization/configuration/configuration.component';
import {SafeImageUrlPipe} from '@components/administration/organization/configuration/branding/safe-image-url.pipe';
import {ContactsModule} from '@components/administration/organization/configuration/contacts/contacts.module';
import {ConstantsModule} from '@components/administration/organization/configuration/constants/constants.module';
import { BrandingPreviewToastComponent } from './branding/branding-preview-toast/branding-preview-toast.component';

@NgModule({
  declarations: [
    BrandingComponent,
    BrandingImageComponent,

    MailSettingsComponent,
    MailPreviewComponent,
    MailTemplateComponent,
    MachinesComponent,
    UsersComponent,
    SettingsComponent,
    ConfigurationComponent,
    SafeImageUrlPipe,
    BrandingPreviewToastComponent,

  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    NgbNavModule,
    TranslateModule,
    ContactsModule,
    ConstantsModule,
    NgbPopoverModule,
    ColorPickerDirective,
    FormsModule
  ],
  exports: [
    BrandingPreviewToastComponent
  ]
})
export class ConfigurationModule {
}
